/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-13 17:15:01
 * @Explain: opt-in 设置
 */
import http from '../http';

const MODEL = '/opt_in';

export default {
  // 获取默认配置
  getDefaultConfig(data: Record<any, any>) {
    return http.post(`${MODEL}/get_default_config`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
        ]),
      },
    });
  },
  // 获取开放地区
  getOpenRegions(data: Record<any, any>) {
    return http.post(`${MODEL}/opt_in_regions`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 发送测试邮件 */
  onTestWelcomeEmail(data: any) {
    return http.post('/contactJoinSetting/send-test-email', data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
        ]),
      },
      //   subject_attributes_default_value
    });
  },
  // 保存配置
  onSaveDefaultConfig(data: Record<any, any>) {
    return http.post(`${MODEL}/save_default_config`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
        ]),
      },
    });
  },
};
